module.exports = __webpack_public_path__ + "img/iterateTuto.b2615850.png";